import React from "react";
import { IconChevronDown } from "./icons";
import { CONTROL, LABEL } from "./controlStyles";

/**
 * The single dropdown for the whole project.
 * options: [{ value, label }]
 */
export default function Select({ label, value, onChange, options, id, className = "", ...rest }) {
  const selectId = id || label?.toLowerCase().replace(/\s+/g, "-");

  const control = (
    <div className="relative inline-block">
      <select
        id={selectId}
        value={value}
        onChange={onChange}
        className={`${CONTROL} min-w-[8rem] cursor-pointer appearance-none pr-9 font-medium ${className}`}
        {...rest}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <IconChevronDown
        aria-hidden="true"
        className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-sm text-slate-500 dark:text-slate-400"
      />
    </div>
  );

  if (!label) return control;

  return (
    <label htmlFor={selectId} className="flex flex-col gap-1.5">
      <span className={LABEL}>{label}</span>
      {control}
    </label>
  );
}
